import { fieldIsInvalid, fieldIsRequired, getValidationResult } from 'shared/utils/tools'
import uuid from 'uuid/v4'
import * as yup from 'yup'

export interface LinkedUser {
  role_id: string
  role_name: string
  role_display_name: string
  role_level: number
  photo_url: string
  full_name: string
}

export interface NoteComment {
  id: string
  status: string
  user_id: string
  note_id: string
  message: string
  type: string
  created_date: Date
  updated_date: Date
  company_id: string
  organization_id: string
}

export interface Attachment {
  id: string
  status: string
  user_id: string
  note_id: string
  comment_id: string
  attachment_url: string
  type: string
  created_date: Date
  updated_date: Date
  company_id: string
  organization_id: string
}

export const noteSchema = yup.object().shape({
  id: yup.string().required(),
  remove_attachment: yup
    .string()
    .nullable()
    .notRequired(),
  attachment: yup
    .string()
    .nullable()
    .notRequired(),
  message: yup.string().notRequired(),
  type: yup
    .string()
    .oneOf(['Late', 'Away', 'Sick', 'Attending'])
    .notRequired(),
  categories: yup
    .array()
    .of(yup.string())
    .notRequired(),
  role_ids: yup
    .array()
    .of(yup.string())
    .notRequired(),
})

export type NoteType = yup.InferType<typeof noteSchema>
export type NoteTypeWithStatus = NoteType & {
  status: string
  user_id: string
  created_by: string
  archive_by?: string
  detail: any
  created_date: Date
  updated_date: Date
  archive_date: Date
  unflag_date: Date
  company_id: string
  organization_id: string
  role_names: string[]
  target_user: LinkedUser
  created_by_user: LinkedUser
  archive_by_user?: LinkedUser
  updated_by_user?: LinkedUser
  unflagged_by_user?: LinkedUser
  note_comment?: NoteComment[]
  attachments?: Attachment[]
  comment_count: number
  is_flagged?: boolean
  is_warned?: boolean
  appointment?: any
  categories?: string[]
}
export function getEmptyNote(): NoteType {
  return {
    id: uuid(),
    message: '',
    categories: [],
    role_ids: [],
  }
}

export default function validator(data: NoteType) {
  return getValidationResult(data, noteSchema)
}
